import { Component, Output, EventEmitter, Input } from '@angular/core';
import { DashboardTabView } from 'src/app/state-management';

@Component({
    selector: 'app-problem-sidenav',
    templateUrl: './problem-sidenav.component.html',
    styleUrls: ['./problem-sidenav.component.scss'],
    standalone: false
})

export class ProblemSideNavComponent {

  @Input() problemNo: string;
  @Input() activeItem: string;
  @Input() showAsset = false;
  @Output() toggleMenuChange = new EventEmitter<DashboardTabView>();

  constructor() { }

  onToggleMenuChange(menu: DashboardTabView) {
    this.toggleMenuChange.emit(menu);
  }

  scrollTo(section: DashboardTabView) {
    this.onToggleMenuChange(section);
    document.querySelector('#' + section)
      .scrollIntoView(true);
  }
}
